import { useEffect, createContext, useContext } from "react";
import { useRouter } from "next/navigation";
import DBService from "@/util/db-service";
import ROUTES from "../../routes";
import Page from "@/components/template-parts/page";
import useUser from "@/lib/useUser";
import useWill from "@/lib/useWill";
import WillEditor from "@/components/views/will-editor/will-editor"; 
import ContentProvider from "@/providers/content-provider";
import type { PageProps } from "@/types";

export const getStaticProps = async () => {
    return { props: { content: await DBService.getPage(ROUTES.WILL.BASE) } as PageProps };
}
const HautajaistestamenttiPage = ( props:PageProps ) => {

    const { authUser, isLoading } = useUser();
    const { will, setWill, gettingWill } = useWill(authUser, 'WILL');
    
    const router = useRouter();

    
    // Redirect if not authenticated
    useEffect( () => {
        if ( ! isLoading && authUser === null ) {
            router.push(`${ROUTES.AUTH.BASE}?redirect=${window.location.pathname}`);
        }
    }, [isLoading, authUser]); 


    
    useEffect( () => {
        
        // Get non archived (editable/completed) will for current user if such exists, otherwise redirect to payment page.
        if ( ! gettingWill && will === null ) {
            router.push(ROUTES.WILL.PAYMENT); 
        }

        // If will status is completed, redirect to download page
        if ( will && will?.status === 'completed' ) {
            router.push(ROUTES.WILL.THANK_YOU);
        }
    }, [gettingWill, will]);  


    return(
       <ContentProvider content={props.content} >
            <Page type="will" title="Luo hautajaistestamentti" loading={( will === null || will?.status === 'completed' )} authUser={authUser}>
                <WillEditor willType="WILL" will={will} setWill={setWill} onFinished={ () => { router.push(ROUTES.WILL.THANK_YOU);  }}  /> 
            </Page>
        </ContentProvider>
    )
}

export default HautajaistestamenttiPage;